import { FieldFunctionOptions, gql } from '@apollo/client'
import { Reference } from '@apollo/client/utilities'

export function purchaseGachaTicketByPoint() {
  return {
    merge(
      existing: Reference,
      incoming: { gachaTicketId: string; count: string },
      { cache, variables, readField, mergeObjects }: FieldFunctionOptions
    ) {
      cache.modify({
        id: 'ROOT_QUERY',
        fields: {
          prepaidPointBalance(existingPrepaidPointBalance = { __ref: '' }) {
            const balance =
              readField<number>('balance', existingPrepaidPointBalance) ?? 0
            const prepaidPointId = readField<string>(
              'prepaidPointId',
              existingPrepaidPointBalance
            )
            return mergeObjects(existingPrepaidPointBalance, {
              balance: balance - (variables?.inputs?.point ?? 0),
              prepaidPointId,
              __typename: 'PrepaidPointBalance',
            })
          },
        },
      })
      const userData = cache.readQuery<{ user: { id: string } }>({
        query: gql`
          query UserDetailCache {
            user {
              id
            }
          }
        `,
      })
      if (!userData) {
        return null
      }
      cache.modify({
        id: cache.identify(userData.user),
        fields: {
          gachaTicket(gachaTicket) {
            return {
              ...gachaTicket,
              __typename: 'UserGachaTicket',
              available: (gachaTicket?.available ?? 0) + incoming.count,
            }
          },
        },
      })
      return null
    },
  }
}
